<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="indexItems"
    :maskFields="maskFields"
    :infoHeaders="infoHeaders"
    @options-change="optionsChange"
    :serverItemsLength="totalItems"
    :loadOptions="options"
    :enableCustomFilters="true"
    :containTopToolbar="false"
    :typeOperators="typeOperators"
    :serverFields="serverFields"
    :changeSwitch="changeSwitch"
    @filter-confirm-action="applyFilters"
    :initialFilters="filters"
  >

  <template slot="link1" slot-scope="{ item }">
      <v-tooltip top v-if="item.sale.nfes.length > 0">
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            text
            icon
            link
            v-on="{ ...tooltip }"
            :to= "'/app/outbound_nfes?saleId=' + item.sale.id"
          >
            <v-badge
              :content="item.sale.nfes.length"
              :value="item.sale.nfes.length"
              color="green"
              overlap
              offset-x="8"
              offset-y="8"
            >
              <v-icon>mdi-file-certificate</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <span>Visualizar NFP-e{{item.sale.nfes.length > 1 ? 's' : ''}}</span>
      </v-tooltip>

      <v-tooltip top v-if="item.sale.nfces.length > 0">
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            text
            icon
            link
            v-on="{ ...tooltip }"
            :to= "'/app/outbound_nfces?saleId=' + item.sale.id"
          >
            <v-badge
              :content="item.sale.nfces.length"
              :value="item.sale.nfces.length"
              color="green"
              overlap
              offset-x="8"
              offset-y="8"
            >
              <v-icon>mdi-receipt</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <span>Visualizar NFC-e{{item.sale.nfces.length > 1 ? 's' : ''}}</span>
      </v-tooltip>
    </template>


    <template v-if="item.nfe.statusKey == 'authorized' || item.nfe.statusKey == 'canceled'" slot="action3" slot-scope="{ item }">
      
      <BasePdfViewer v-if="item.nfe.statusKey == 'authorized' && item.nfe.type == 'NFPE'"
        :pdfSource="item.nfe.pdf"
        :loading="false"
        :pdfTitle="'NF-e-' + item.nfe.series + '-' + item.nfe.number"
        @pdf-open-action="getNfePdf(item.nfe, function() {return null;})"
        ref="nfePdfRef"
      />
      <BasePdfViewer v-if="item.nfe.statusKey == 'canceled'"
        :pdfSource="item.nfe.pdf"
        :loading="false"
        pdfTitle="Danfe de Cancelamento"
        @pdf-open-action="getNfeCancellationPdf(item.nfe, function() {return null;})"
        ref="nfeCancellationPdfRef"
      />
    </template>

   <template slot="show" slot-scope="{ item }" v-if="$can('read', $router.currentRoute.name)">
      <Edit
        :entry="item"
        :readOnly="true"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="action1" slot-scope="{ item }" v-if="$can('read', 'Sale')">
      <SaleEdit
        :entry="item.sale"
        @entry-updated="entryUpdated"        
        @entry-canceled="loadServerEntries()"
        :modelNameSingular="saleName"
        :readIcon="saleIcon"
        :readOnly="true"
        :isEdit="false"
      />
    </template>

  </BaseIndex>
</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
import BasePdfViewer from "@shared_components/base_pdf_viewer.vue";
// import SaleNew from "@models/sales/new.vue";
// import Loss from "@models/storages/storage_adjustments/exit_storage_adjustments/new.vue";
// import NewSeedPlotOperation from "@models/operations/seed_plot_operations/new.vue";
import Edit from "./edit.vue";
import SaleEdit from "@models/sales/edit.vue";
// import Delete from "./delete.vue";
// import PlanningOperationShow from "../planning_operations/edit.vue"

export default {
  data() {
    return {
      indexItems: [],
      saleItemLots: [],
      loading: true,
      pageLoading: false,
      totalItems: 0,
      tableHeaders: [
        { text: "Variedade", align: "left", sortable: true, value: "variety"},
        { text: "Lote", align: "left", sortable: true, value: "saleLot"},
        // { text: "Lote", align: "left", sortable: true, value: "cropLot"},
        { text: "Lote", align: "left", sortable: true, value: "cropLot"},
        // { text: "Lote", align: "left", sortable: true, value: "plantLot"},
        { text: "Lote", align: "left", sortable: true, value: "originalLot"},
        // { text: "Lote", align: "left", sortable: true, value: "oldPlantLot"},
        // { text: "Lote", align: "left", sortable: true, value: "oldCropLot"},
        { text: "Cliente", align: "left", sortable: true, value: "clientName"},
        { text: "Venda", align: "left", sortable: true, value: "saleDate"},
        { text: "Número", align: "left", sortable: true, value: "nfeNumber"}, //numero da nota !!!
        { text: "NF-e", align: "left", sortable: false, value: "link" },
        // { text: "Selecionado", align: "left", sortable: false, value: "selected"},
        { text: "Ações", align: "left", sortable: false, value: "action" },
      ],
      maskFields: [
        { field: 'saleDate', mask: 'date'},
        // { field: 'periodsNamesList', mask: 'tag', color: 'success', outlined: true }, 
        // { field: 'periodsTotalArea', mask: 'number_unit', unit: 'ha' },
        // { field: 'saleQuantity', mask: 'number_unit', unit: 'un' },
        // { field: 'availableQuantity', mask: 'number_unit', unit: 'un' },
        // { field: 'sown', mask: 'number_unit', unit: 'un' },
        // { field: 'lossQuantity', mask: 'number_unit', unit: 'un' },
      ],
      infoHeaders: [
        // { field: 'varietyNames', info: 'Variedades, fertilizantes, agrotóxicos e biológicos consumidos nas operações. *Em operações de destinar semeios as variedades indicadas são as geradas.' },
        { field: 'saleLot', info: 'Venda'},
        { field: 'cropLot', info: 'Semeio-Destinação'},
        { field: 'plantLot', info: 'Semeio'},
        { field: 'originalLot', info: 'Semente'},
        { field: 'oldCropLot', info: 'Destinação antigo'},
        { field: 'oldPlantLot', info: 'Semeio antigo'},

      ],
      options: { //objeto específico para configurar e armazenar as informações da paginação e ordenação.
        page: 1,
        itemsPerPage: 10,
        sortBy: ["id"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [
        // {field: "availableQuantity", fieldValues: [0], key: 0, operator: "gt", type: "decimal"}
        ], //array para armazenar os filtros inseridos pelo usuário
      typeOperators: [], //array que traz do banco os operadores que serão utilizados nos filtros
      serverFields: [], // array que traz do banco quais os campos que podem ser aplicados filtros
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "Lote de Venda"
    },
    modelNamePlural: {
      type: String,
      default: "Lotes de Venda"
    },
    saleName: {
      type: String,
      default: "Venda"
    },
    editIcon: {
      type: String,
      default: "mdi-pencil"
    },
    saleIcon:{
      type: String,
      default: "mdi-eye-outline"
    },
  },
  components: {
    BaseIndex: BaseIndex,
    BasePdfViewer: BasePdfViewer,
    // SaleNew: SaleNew,
    // Loss: Loss,
    // NewSeedPlotOperation: NewSeedPlotOperation,
    // New: New,
    SaleEdit: SaleEdit,
    Edit: Edit,
    // Delete: Delete,
    // PlanningOperationShow: PlanningOperationShow
  },
  created() {    
    this.loadServerEntries();
  },
  computed: {
    // maskFields() {
    //   return [
    //     { field: 'sownDate', mask: 'date'},
    //     ... this.$vuetify.breakpoint.smAndDown ? [] : [{ field: 'periodsNamesList', mask: 'tag', color: 'success', outlined: true }], 
    //     { field: 'periodsTotalArea', mask: 'number_unit', unit: 'ha' },
    //   ]
    // }
  },
  methods: {
    applyFilters: function(filtersList) {
      this.filters = filtersList;
      this.options.page = 1;
      this.loadServerEntries();
    },
    loadServerEntries: function() {
      this.loading = true;
      // console.log(this.filters);
      this.$apollo
        .query({
          query: LOAD_ALL_SALE_LOTS,
          variables: {
            input: { //todo index com paginação, ordenação e filtros server-side precisa enviar essas informações quando fizer a busca por dados
              limit: this.options.itemsPerPage,
              offset: (this.options.page - 1) * this.options.itemsPerPage,
              sortBy: this.options.sortBy,
              sortDesc: this.options.sortDesc,
              fields: this.tableHeaders.map(val => val.sortable ? (val.filter_value ? val.filter_value : val.value) : null).filter(val => val != null),
              filters: this.filters
            }
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // this.executionOperations = response.data.groundContext.allExecutionOperations;
          // console.log("All executionOperations", response.data.groundContext.executionOperationsIndex);
          this.indexItems = response.data.accountContext.saleLotViewIndexFiltersIndex.saleLotViewIndexFilters; //seta os itens retornados do servidor para o array de itens que será exibido na tabela

          // this.indexItems.forEach((item)=>{
          //   item.selected = "Não";
          // });
          
          this.totalItems = response.data.accountContext.saleLotViewIndexFiltersIndex.count; // seta o numero total de itens, como a paginação limita a quantidade de itens, o componente precisa saber qual o máximo de itens para configurar o componente na interface e calcular o número de páginas 
          this.typeOperators = response.data.accountContext.saleLotViewIndexFiltersIndex.typeOperators; //seta os operadores que podem ser utilizados nos filtros
          this.serverFields = response.data.accountContext.saleLotViewIndexFiltersIndex.serverFields; // seta os campos que podem ser filtrados
          // console.log(this.serverFields);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    downloadNfePdf: function(nfe, fileName) {
      this.getNfePdf(nfe, function(pdfFile){
        const downloadLink = document.createElement("a");
        downloadLink.href = pdfFile;
        downloadLink.download = fileName + '.pdf';
        downloadLink.click();
      });
    },
    getNfePdf: function(nfe, callback) {
      if (nfe.pdf) {
        callback(nfe.pdf);
      }
      this.pageLoading = true;

      this.$apollo
        .mutate({
          mutation: DOWNLOAD_NFE_PDF_MUTATION,
          variables: {
            nfpeId: nfe.id
          },
        })
        .then(response => {
          var response_data="";
          response_data = response.data.downloadNfpePdf;
          var errors = response_data.errors
          // console.log(errors)
          if (errors.length > 0){
            this.indexErrors = errors;
            this.$refs.nfePdfRef.closeDialog();
          } else {
            let pdfFile = "data:application/octet-stream;base64," + response_data.nfpe.nfePdf
            this.$set(nfe, 'pdf', pdfFile);
            callback(pdfFile);
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    downloadNfeCancellationPdf: function(nfe, fileName) {
      this.getNfeCancellationPdf(nfe, function(pdfFile){
        const downloadLink = document.createElement("a");
        downloadLink.href = pdfFile;
        downloadLink.download = fileName + '.pdf';
        downloadLink.click();
      });
    },
    getNfeCancellationPdf: function(nfe, callback) {
      if (nfe.pdf) {
        callback(nfe.pdf);
      }
      this.pageLoading = true;

      this.$apollo
        .mutate({
          mutation: DOWNLOAD_NFE_CANCELLATION_PDF_MUTATION,
          variables: {
            nfpeId: nfe.id
          },
        })
        .then(response => {
          var response_data = "";
          response_data = response.data.downloadNfpeCancellationPdf;
          var errors = response_data.errors
          // console.log(errors)
          if (errors.length > 0){
            this.indexErrors = errors;
            this.$refs.nfeCancellationPdfRef.closeDialog();
          } else {            
            let pdfFile = "data:application/octet-stream;base64," + response_data.nfpe.nfeCancellationPdf;
            this.$set(nfe, 'pdf', pdfFile);
            callback(pdfFile);
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    entryUpdated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    optionsChange: function(opts) {
      this.options = opts;
      this.loadServerEntries();
    },
    changeSwitch(item){      
      if (item.selected == false){
        this.saleItemLots = this.saleItemLots.filter(function(id){
          return id !== item.id;
        });
      }else{
        this.saleItemLots.push(item.id);
      }
      // console.log(this.saleItemLots);
    },
  }
};

const LOAD_ALL_SALE_LOTS = gql `
  query($input: IndexInputObject!) {
    accountContext {
      saleLotViewIndexFiltersIndex(input: $input){
        count
        typeOperators
        serverFields
        saleLotViewIndexFilters {
          id
          saleLotId
          clientName
          cropLot
          saleLot
          originalLot
          saleDate
          variety
          nfeNumber
          nfe{
            id
            statusKey
            type
            number
            series
          }
          nfce{
            id
            statusKey
            type
            number
            series
          }
          sale{
            id
            statusKey
            nfes {
              id
              status
            }
            nfces {
              id
              status
            }
          }
        }
      }
    }
  }
`;

const DOWNLOAD_NFE_PDF_MUTATION = gql `
  mutation($nfpeId: ID!){
    downloadNfpePdf(
      input: {
        nfpeId: $nfpeId
    }) {
      nfpe{
        nfePdf
      }
      errors
    }
  }
`;

const DOWNLOAD_NFE_CANCELLATION_PDF_MUTATION = gql `
  mutation($nfpeId: ID!){
    downloadNfpeCancellationPdf(
      input: {
        nfpeId: $nfpeId
    }) {
      nfpe{
        nfeCancellationPdf
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
